import React from "react";
import { Link, browserHistory } from "react-router";
import CustomSearch from "./CustomSearch";
import { CountriesList, BPList } from "../../slplusTools";

function TeamMembersHeader({
  searchKeyword,
  handleCustomSearch,
  handleKeyPress,
  clearSearch,
  handleExportToExcel,
  category,
  constants,
  country,
  owner,
  handleCountry,
  handleOwner,
  onOpenAdditionalFilters,
}) {
  const handleAddNew = () => {
    browserHistory.push({
      pathname: "/prospects/create",
      state: {
        from: window.location.pathname + window.location.search,
      },
    });
  };

  return (
    <div className="card-header">
       

      <div className="row align-items-center">
        {/* Search */}
        <div className="col-lg-3 col-md-12 mb-2">
          <CustomSearch
            searchKeyword={searchKeyword}
            handleCustomSearch={handleCustomSearch}
            handleKeyPress={handleKeyPress}
            clearSearch={clearSearch}
          />
        </div>

        {/* Country / BP / Additional Filter */}
        <div className="col-lg-6 col-md-12 mb-2">
          <div className="row align-items-center">
            {category === constants.CATEGORY.INTL_OFFICE && (
              <div className="col-lg-4 col-md-4 mb-2">
                <CountriesList
                  type="vertical"
                  selectedCountry={country}
                  onSelectItem={({ id }) => handleCountry(id)}
                />
              </div>
            )}

            {(category === constants.CATEGORY.INTL_OFFICE ||
              category === constants.CATEGORY.COUNTRY_OFFICE) && (
              <div className="col-lg-4 col-md-4 mb-2">
                <BPList
                  selectedBp={owner === "all" ? null : owner}
                  type="vertical"
                  country={country}
                  onSelectItem={({ value }) => handleOwner(value)}
                />
              </div>
            )}

            <div className="col-lg-2 col-md-2">
              <button
                type="button"
                className="settings_btn btn btn-light"
                style={{ minHeight: "40px" }}
                onClick={onOpenAdditionalFilters}
                title="Apply Additional Filters"
              >
                <i className="fa fa-filter mt-1" />
              </button>
            </div>
          </div>
        </div>

        {/* Right Actions */}
        <div className="col-lg-3 col-md-12 mb-2 text-lg-right text-md-left text-left">
          <div className="d-inline-block mr-2">
            <div className="dropdown">
              <button
                title="More actions"
                className="btn btn-outline-secondary dropdown-toggle"
                type="button"
                id="moreDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                More
              </button>

              <div
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby="moreDropdown"
              >
                <button
                  className="dropdown-item"
                  type="button"
                  onClick={handleExportToExcel}
                >
                  Export
                </button>
              </div>
            </div>
          </div>

          <div className="d-inline-block">
            <div className="dropdown">
              <button
                title="Add"
                className="btn btn-primary dropdown-toggle"
                type="button"
                id="addDropdown"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Add
              </button>

              <div
                className="dropdown-menu dropdown-menu-right"
                aria-labelledby="addDropdown"
              >
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={handleAddNew}
                >
                  Add New
                </button>

                <Link className="dropdown-item" to="/prospects/bulk-upload">
                  Bulk Upload
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamMembersHeader;